import ClearIcon from '@mui/icons-material/Clear'
import SaveIcon from '@mui/icons-material/Save'
import { Box, Grid, Switch, TextField } from '@mui/material'
import Button from '@mui/material/Button'
import { message } from 'antd'
import { useFormik } from 'formik'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'
import { closeModal } from '../../../../../../store/reducers/modal/modal.slice'
import { ERRORS_MESSAGE_MAPPER } from '../../../../../constants/errors'
import { axiosInstance } from '../../../../../hooks/useAxios'
import { ICustomerBlackList } from '../../../../../types/customerBlackList'

interface ICustomerBlackListFormModalProps {
  customerBlackList?: ICustomerBlackList
  fix?: boolean
  onUpdateCustomerBlackListSuccess: () => void
}

interface ICustomerBlackListFormModal {
  name: string
  phoneNumber: string
  isActive?: boolean
}

export const CustomerBlackListFormModal = (
  props: ICustomerBlackListFormModalProps,
) => {
  const dispatch = useDispatch()
  const { isOpen } = useSelector((state: any) => state.modal)
  const {
    customerBlackList,
    onUpdateCustomerBlackListSuccess,
    fix = false,
  } = props

  useEffect(() => {
    if (customerBlackList) {
      formik.setValues({
        name: customerBlackList?.name || '',
        phoneNumber: customerBlackList?.phoneNumber || '',
        isActive: customerBlackList?.isActive,
      })
    }
  }, [customerBlackList])

  const formik = useFormik<ICustomerBlackListFormModal>({
    initialValues: {
      name: '',
      phoneNumber: '',
      isActive: true,
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required('กรุณากรอกชื่อ - นามสกุล')
        .min(1, 'ชื่อ - นามสกุลต้องมีอย่างน้อย 1 ตัวอักษร'),
      phoneNumber: Yup.string()
        .required('กรุณากรอกหมายเลขโทรศัพท์')
        .matches(
          /^[0-9]{9,12}$/,
          'กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง (9-12 ตัว)',
        ),
    }),
    onSubmit: async (values: ICustomerBlackListFormModal) => {
      const isUpdate = !!customerBlackList?.objectId
      try {
        await axiosInstance.request({
          method: isUpdate ? 'PUT' : 'POST',
          url: isUpdate
            ? `/blacklists/${customerBlackList?.objectId}`
            : '/blacklists',
          data: {
            ...values,
          },
        })
        message.success('บันทึกข้อมูลสำเร็จ')
        formik.resetForm()
        dispatch(closeModal())
        onUpdateCustomerBlackListSuccess()
      } catch (e: any) {
        const messageError =
          ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
          'บันทึกข้อมูลไม่สำเร็จ'
        message.error(messageError)
      }
    },
  })

  return (
    <Box component="form" mt={1} onSubmit={formik.handleSubmit}>
      <Grid container spacing={2} justifyContent="space-between">
        <Grid item xs={12} lg={12}>
          <TextField
            disabled={fix}
            id="name"
            fullWidth
            label="กรอกชื่อ - นามสกุล"
            name="name"
            helperText={formik.touched.name && (formik.errors.name as string)}
            error={!!(formik.touched.name && formik.errors.name)}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values.name}
          />
        </Grid>
        <Grid item xs={12} lg={12}>
          <TextField
            disabled={fix}
            id="phoneNumber"
            fullWidth
            label="กรอกหมายเลขโทรศัพท์"
            name="phoneNumber"
            helperText={
              formik.touched.phoneNumber &&
              (formik.errors.phoneNumber as string)
            }
            error={!!(formik.touched.phoneNumber && formik.errors.phoneNumber)}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values.phoneNumber}
          />
        </Grid>
        <Grid item xs={12} lg={12}>
          <label>เปิดการใช้งาน</label>
          <Switch
            disabled={fix}
            checked={formik.values.isActive}
            onChange={() => {
              formik.setFieldValue('isActive', !formik.values.isActive)
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={2} justifyContent={'flex-end'}>
        <Grid item>
          <Button
            startIcon={<SaveIcon />}
            color="primary"
            type="submit"
            size="large"
            variant="contained"
          >
            {!!customerBlackList?.objectId
              ? 'แก้ไขลูกค้า BlackList'
              : 'สร้างลูกค้า BlackList'}
          </Button>
        </Grid>
        <Grid item>
          <Button
            color="inherit"
            size="large"
            variant="contained"
            onClick={() => dispatch(closeModal())}
            startIcon={<ClearIcon />}
          >
            ปิดหน้าต่าง
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}
